import { TradeMethodAutomationSourcesPage } from 'features/trade-methods';

export const AdminTradeMethodAutomationSourcesPage = () => (
  <TradeMethodAutomationSourcesPage />
);
